import { Component, OnInit, ViewChild } from '@angular/core';
import { Params } from '@angular/router';
import { catchError, map, switchMap } from 'rxjs/operators';
import { UserHistoryService } from './user-history.service';
import { Router, ActivatedRoute } from '@angular/router';
import { SkillTreeService } from '../skill-tree-by-course/skill-tree.service';
import { of } from 'rxjs';
import { ModalComponent } from 'src/app/shared/components/modal/modal.component';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { ppid } from 'process';
import THBText from 'thai-baht-text'
import pdfMake from 'pdfmake/build/pdfmake';
import { DatePipe } from 'src/app/shared/pipe/date.pipe';
import { Logo } from 'src/app/shared/logo-encode';
import { MatTabGroup } from '@angular/material/tabs';
import { LogoChulaBlackWhite } from 'src/app/shared/logo-chula-black-white';
import { AuthService } from 'src/app/core/services/auth/auth.service';
import { OldChulaLogo_Base64 } from 'src/app/shared/old-chula-logo-base64';
import { WaterMark } from 'src/app/shared/water-mark';
import { Signature } from 'src/app/shared/signature';

@Component({
  selector: 'app-user-history',
  templateUrl: './user-history.component.html',
  styleUrls: ['./user-history.component.scss']
})
export class UserHistoryComponent implements OnInit {
  measureHistory = [];
  researchHistory = [];
  mySkillTree = [];
  paymentHistory;
  waitPay;
  paid;
  cancel;
  reject = [];
  isLoading: boolean = false;
  selectIndex: number;
  rejectIndex: string;
  today = new Date();

  accountId: string = '';
  isPrint: boolean = false;
  receiptDetail: any;

  token: string;

  constructor(
    private userHistoryService: UserHistoryService,
    private skillTreeService: SkillTreeService,
    private router: Router,
    private route: ActivatedRoute,
    public matDialog: MatDialog,
    private _authService: AuthService,
  ) {
    this._authService.token.subscribe(res => this.token = res);
  }

  ngOnInit(): void {

    if (!this.token) {
      this.openLogin()
    } else {
      this.rejectIndex = new URL(location.href).searchParams.get('index');

      if (this.rejectIndex) {
        this.selectIndex = this.rejectIndex === '2' ? 2 : 0;
      } else {
        this.selectIndex = window.history.state.statusPay === 'reject' ? 2 : 0;
      }

      this.userHistoryService.getMeasureHistory().pipe(
        switchMap(measure => {
          this.measureHistory = measure.result;
          // // console.log(this.measureHistory);
          // // console.log(measure);

          return this.userHistoryService.getResearchHistory().pipe(
            switchMap(res => {
              this.researchHistory = res.result;
              // // console.log(this.researchHistory);
              return this.userHistoryService.getPaymentHistory().pipe(
                map(pay => {
                  console.log(pay);
                  this.waitPay = pay.result.wait_pay;
                  this.paid = pay.result.paid;
                  this.cancel = pay.result.cancel;
                  // this.reject = pay.result.reject;
                  let type;
                  pay.result.reject.forEach(e => {
                    if (e.REF_ID.charAt(0) === 'C' && e.REF_ID.charAt(1) === 'S') {
                      type = 'consult';
                    } else if (e.REF_ID.charAt(0) === 'C') {
                      type = 'course';
                    } else if (e.REF_ID.charAt(0) === 'W') {
                      type = 'workshop';
                    } else if (e.REF_ID.charAt(0) === 'R') {
                      type = 'report'
                    }

                    this.reject.push({
                      PAYMENT_NAME: e.PAYMENT_NAME,
                      PAYMENT_ID: e.PAYMENT_ID,
                      PRICE: e.PRICE,
                      REF_ID: e.REF_ID,
                      STATUS: e.STATUS,
                      PAYMENT_DATE: new Date(e.PAYMENT_DATE),
                      REMARK: e.REMARK,
                      TYPE: type,
                    })
                  });
                  // console.log(this.reject);
                })
              )
            }),
            switchMap(() => {
              return this.skillTreeService.getMySkillTree().pipe(
                map(skilltree => {
                  this.mySkillTree = [...new Set(skilltree.result)];
                  // // console.log(skilltree);
                })
              )
            })
          )
        })
      ).subscribe();
    }

  }


  transfer(rid) {
    // // console.log(rid);
    let type;
    if (rid.charAt(0) === 'C' && rid.charAt(1) === 'S') {
      type = 'CS';
    } else {
      type = rid.charAt(0);
    }

    let t;
    switch (type) {
      case 'W': {
        t = 'workshop'
        break;
      }
      case 'C': {
        t = 'course'
        break;
      }
      case 'R': {
        t = 'report'
        break;
      }
      case 'CS': {
        t = 'consult'
        break;
      }


    }

    const queryParams: Params = { id: rid, type: t };
    this.router.navigate(
      ['/payment'],
      {
        relativeTo: this.route,
        queryParams: queryParams,
        queryParamsHandling: 'merge',
      });

  }

  cancelPayment(pid, rid, pname) {
    // // console.log(rid);
    let type;
    if (rid.charAt(0) === 'C' && rid.charAt(1) === 'S') {
      type = 'CS';
    } else {
      type = rid.charAt(0);
    }

    let t;
    switch (type) {
      case 'W': {
        t = 'workshop'
        break;
      }
      case 'C': {
        t = 'course'
        break;
      }
      case 'R': {
        t = 'report'
        break;
      }
      case 'CS': {
        t = 'consult'
        break;
      }
    }

    let body = {
      PAYMENT_ID: pid,
      TYPE: t
    }
    const dialogConfig = new MatDialogConfig();

    dialogConfig.disableClose = true;
    dialogConfig.id = 'modalConfirm';
    dialogConfig.autoFocus = false;

    dialogConfig.data = {
      title: 'ยกเลิกการซื้อ',
      description: `<p>คุณต้องการยกเลิกรายการ "<b>${pname}</b>" ใช่หรือไม่?</p>`,
      cancleBtnText: 'ย้อนกลับ',
      actionBtnText: 'ตกลง',
      isDelete: true
    }

    const formDialog = this.matDialog.open(ModalComponent, dialogConfig);
    this.isLoading = true;
    formDialog.afterClosed().pipe(

      switchMap(isDelete => {
        if (isDelete) {
          return this.userHistoryService.cancelPayment(body).pipe(
            switchMap(res => {
              if (res) {
                this.isLoading = false;
                dialogConfig.disableClose = true;
                dialogConfig.id = 'modalConfirm';
                dialogConfig.width = '350px';
                dialogConfig.data = {
                  title: 'ยกเลิกการสั่งซื้อ',
                  description: `<img src="../../../assets/check.png" width="100px;" class="img-center">
                              <p class="title text-center">ยกเลิกการสั่งซื้อสำเร็จ</p>`,
                  cancleBtnText: 'ยืนยัน',
                  customStyle: 'background-color: #58595B'
                }
              }

              const modal = this.matDialog.open(ModalComponent, dialogConfig);
              return modal.afterClosed().pipe(
                map(r => {
                  if (!r) {
                    location.reload();
                  }
                })
              )
            })
          )
        } else {
          this.isLoading = false;
          // // console.log(isDelete);
          return of(null)
        }
      }),
      catchError((err) => {
        // console.log(err);
        alert(err.error.message);
        this.router.navigate(['/']);
        return of(null);
      }),
    ).subscribe();

  }

  receipt(pid, aid) {
    // // console.log(pid);
    this.accountId = aid;
    let receipt;

    this.userHistoryService.getReceiptById(pid).pipe(
      map(res => {
        // console.log(res.result);
        if (res.success) {
          let printDate = new Date(res.result[0].PAYMENT_DATE)
          receipt = {
            address: `จุดรับเงิน: คณะจิตวิทยา จุฬาลงกรณ์มหาวิทยาลัย
            อาคารบรมราชชนนีศรีศตพรรษ ชั้น 7 แขวงวังใหม่ เขตปทุมวัน กรุงเทพมหานคร 10330
            โทรศัพท์: 02-218-1185 โทรสาร: 02-218-1339 เลขที่ผู้เสียภาษี: 0994000163860 สาขา: 3800`,
            thbath: res.result[0].PAYMENT_PRICE > 0 ? THBText(res.result[0].PAYMENT_PRICE) : 'ศูนย์บาท',
            discount: res.result[0].PAYMENT_PRICE === res.result[0].STANDARTPRICE ? 0 : res.result[0].STANDARTPRICE - res.result[0].SPECIALPRICE,
            price: res.result[0].REMARK_PRICE ? res.result[0].REMARK_PRICE : res.result[0].PAYMENT_PRICE,
            standardPrice: res.result[0].STANDARTPRICE,
            specialPrice: res.result[0].SPECIALPRICE,
            type: res.result[0].PAYMENT_TYPE === '2C2P' ? 'บัตรเครดิต/เดบิต' : 'เงินโอน',
            paymentID: res.result[0].PAYMENT_ID,
            signaturePic1: Signature[0].signature,
            signatureName1: Signature[0].signatureName,
            signatureJobTitle1: Signature[0].position,
            signaturePic2: Signature[1].signature,
            signatureName2: Signature[1].signatureName,
            signatureJobTitle2: Signature[1].position,
            userName: res.result[0].NAME,
            userPhone: res.result[0].PHONENUMBER,
            taxID: res.result[0].TAX_NO,
            userAddress: res.result[0].ADDRESS,
            date: new DatePipe().transform(res.result[0].PAYMENT_DATE.toString(), 'full'),
            bankDate: new Date(res.result[0].PAYMENT_DATE),
            printDate: `${new DatePipe().transform(res.result[0].PAYMENT_DATE.toString(), 'full')} - ${printDate.getHours() > 9 ? '' : 0}${printDate.getHours()}:${printDate.getMinutes() > 9 ? '' : 0}${printDate.getMinutes()} น.`,
            paymentName: res.result[0].PAYMENT_NAME,
            receiptId: res.result[0].RECEIPT_ID,
            cardNo: res.result[0].CARD_NO,
          }

          // this.openPdf(receipt);
          this.receiptDetail = receipt;
          this.isPrint = true;
          setTimeout(() => {
            this.isPrint = false;
            this.accountId = '';
          }, 1000);

        }
      }),
      catchError((err) => {
        // console.log(err);
        alert(err.error.message);
        this.router.navigate(['/'])
        return of(null);
      }),
    ).subscribe();

  }

  recenter(i) {
    if (i === 1) {
      this.mySkillTree.map(val => {
        val.NODES = [...val.NODES];
        val.CLUSTER_NODES = [...val.CLUSTER_NODES];
        val.LINKS = [...val.LINKS];
      })
    }
  }

  openLogin() {
    this.router.navigate(['login'], { state: { redirect: this.router.url } })
  }

  openMeasure(link) {
    window.open(`/measure/${link}`, '_blank')
  }

  openResearch(rsid) {
    window.open(`/research/research-detail?research_id=${rsid}`, '_blank')
  }
}
